import fetchOrders from '../../../Services/fetchOrders'

export default () => (dispatch) => {

  dispatch(fetchOrders())

}
